import logo from '../assets/logo.png';

function Flag({ h=4 }) {
  return <div className="flag" style={{ height:h }}><span /><span /><span /></div>;
}

export default function Home({ go }) {
  return (
    <>
      {/* HERO */}
      <section className="home-hero">
        <img src={logo} alt="" className="deco deco-tr" />
        <img src={logo} alt="" className="deco deco-bl" />
        <div className="wrap">
          <div className="hero-badge">
            <span className="dots">
              <span className="dot" style={{ background:'#FF9933' }} />
              <span className="dot" style={{ background:'#fff', border:'1px solid #DEE2E6' }} />
              <span className="dot" style={{ background:'#138808' }} />
            </span>
            <span>Registered in India</span>
          </div>

          <div className="hero-grid">
            <div>
              <h1 className="hero-h1">
                Every Government Scheme <span className="hero-highlight">You Qualify For</span> — In One Place
              </h1>
              <p className="hero-hindi">हर सरकारी योजना जिसके आप पात्र हैं — एक जगह</p>
              <p className="hero-desc">
                <strong>YojanaSaathi</strong> takes your details once — age, income, occupation — and surfaces every central and state scheme you're actually eligible for. Then lets you apply right there.
              </p>
              <div className="hero-btns">
                <button className="btn btn-saffron" onClick={()=>go('for-citizens')}>
                  Find My Schemes
                  <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <button className="btn btn-outline" style={{ color:'#000080' }} onClick={()=>go('how-it-works')}>
                  How It Works
                </button>
              </div>
              <div className="hero-trust">
                {[{i:'🔒',t:'Privacy-first design'},{i:'✅',t:'Citizens & Businesses'},{i:'🇮🇳',t:'28 States Covered'}].map(x=>(
                  <span key={x.t} className="item">{x.i} {x.t}</span>
                ))}
              </div>
            </div>

            {/* Phone mockup */}
            <div className="phone-wrap">
              <div className="phone-shell">
                <div className="phone-screen">
                  <div className="phone-notch"><div className="phone-notch-bar"/></div>
                  <div className="phone-head">
                    <Flag h={2}/>
                    <div className="ph-app">YojanaSaathi</div>
                    <div className="ph-title">Your Matched Schemes</div>
                    <div className="ph-sub">आपकी पात्र योजनाएं</div>
                  </div>
                  <div className="phone-body">
                    <div className="phone-label">Your Profile</div>
                    {[['Annual Income','₹ 2,40,000'],['Occupation','Farmer · किसान']].map(([k,v])=>(
                      <div key={k} className="phone-field">
                        <span style={{color:'#718096'}}>{k}</span>
                        <span style={{fontWeight:700,color:'#1A1A2E'}}>{v}</span>
                      </div>
                    ))}
                    <div className="phone-divider"/>
                    <div className="phone-label">Schemes You Qualify For</div>
                    {[
                      {name:'PM-Kisan Samman Nidhi',desc:'₹6,000/year income support',c:'#138808'},
                      {name:'Soil Health Card Scheme',desc:'Free soil testing',c:'#CC6600'},
                    ].map(s=>(
                      <div key={s.name} className="phone-scheme" style={{background:`${s.c}1A`,border:`1px solid ${s.c}40`}}>
                        <div className="phone-scheme-top">
                          <span className="phone-scheme-name">{s.name}</span>
                          <span className="phone-scheme-badge" style={{background:s.c}}>Eligible</span>
                        </div>
                        <div className="phone-scheme-desc">{s.desc}</div>
                      </div>
                    ))}
                    <div className="phone-apply">Apply for PM-Kisan →</div>
                  </div>
                </div>
              </div>
              <div className="float-badge fb1">
                <div className="f-icon" style={{background:'rgba(19,136,8,.12)'}}>✅</div>7 Schemes Found
              </div>
              <div className="float-badge fb2">
                <div className="f-icon" style={{background:'rgba(204,102,0,.12)'}}>📋</div>Applied in-app
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TRUST BAR */}
      <div className="trust-bar">
        <Flag h={3}/>
        <div className="inner">
          {[
            {i:'🛡️',t:'Your data stays with you'},
            {i:'🔄',t:'Schemes refreshed regularly'},
            {i:'🏛️',t:'Central & State coverage'},
            {i:'📱',t:'Apply without leaving the app'},
            {i:'🆓',t:'100% free — no agents, no fees'},
          ].map(x=><div key={x.t} className="item">{x.i} {x.t}</div>)}
        </div>
        <Flag h={3}/>
      </div>

      {/* STATS */}
      <div className="stats-band">
        <div className="stats-grid">
          {[
            {n:'500+',l:'Schemes Tracked',s:'योजनाएं'},
            {n:'28',l:'States Covered',s:'राज्य'},
            {n:'2 Min',l:'To See Matches',s:'में परिणाम'},
            {n:'100%',l:'Free to Use',s:'बिल्कुल मुफ़्त'},
          ].map(s=>(
            <div key={s.n}>
              <div className="stat-num">{s.n}</div>
              <div className="stat-label">{s.l}</div>
              <div className="stat-sub">{s.s}</div>
            </div>
          ))}
        </div>
        <Flag h={4}/>
      </div>

      {/* FEATURES */}
      <section className="home-features">
        <div className="wrap">
          <div className="features-header">
            <span className="tag" style={{color:'#000080'}}>
              <span className="tag-bar" style={{background:'#000080'}}/>
              What We Offer · हम क्या करते हैं
              <span className="tag-bar" style={{background:'#000080'}}/>
            </span>
            <h2>Built for Every Indian</h2>
          </div>
          <div className="features-grid">
            {[
              {icon:'👨‍👩‍👧‍👦',color:'#FF9933',id:'for-citizens',title:'For Citizens',sub:'नागरिकों के लिए',desc:'Find schemes for health, education, housing, farming — matched to your exact profile.'},
              {icon:'🏢',color:'#138808',id:'for-businesses',title:'For Businesses',sub:'व्यवसायों के लिए',desc:'Subsidies, loan guarantees, export incentives matched to your actual business profile.'},
              {icon:'⚙️',color:'#000080',id:'how-it-works',title:'How It Works',sub:'यह कैसे काम करता है',desc:'Three simple steps from your details to a submitted application — no separate portals.'},
            ].map(c=>(
              <div key={c.id} className="card" style={{borderTop:`4px solid ${c.color}`}}>
                <div style={{fontSize:30,marginBottom:14}}>{c.icon}</div>
                <h3 style={{fontFamily:'Georgia,serif',fontSize:19,color:'#1A1A2E',marginBottom:3}}>{c.title}</h3>
                <div style={{fontSize:11,color:c.color,fontWeight:700,textTransform:'uppercase',letterSpacing:'.06em',marginBottom:12}}>{c.sub}</div>
                <p style={{fontSize:14,color:'#4A5568',lineHeight:1.62,marginBottom:20}}>{c.desc}</p>
                <button className="btn btn-outline" style={{color:c.color,borderColor:c.color,fontSize:13}} onClick={()=>go(c.id)}>Explore →</button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
